import { FormField, fieldA11y } from '@/components/FormField';
import { Icon } from '@/components/Icon';
import { Input } from '@/components/ui/input';
import type { EnvVarFormApi } from './useEnvVarForm';

const KEY_HINT = 'Uppercase, digits and underscores · EXPO_PUBLIC_* is inlined into the JS bundle';

/** The key input (read-only while editing); EXPO_PUBLIC_* keys get a warning banner under it. */
export function EnvVarKeyField({ form }: { form: EnvVarFormApi }) {
  const error = form.errorFor('key', form.values.key.length > 0);
  return (
    <>
      <FormField id="env-var-key" label="Key" required hint={KEY_HINT} error={error}>
        <Input data-testid="env-var-key" value={form.values.key} readOnly={form.edit} onChange={(e) => form.setKey(e.target.value)} placeholder="EXPO_PUBLIC_API_URL" className="font-mono sm:text-[13px]" spellCheck={false} autoComplete="off" maxLength={256} {...fieldA11y('env-var-key', error)} />
      </FormField>
      {form.expo ? <ExpoBanner /> : null}
    </>
  );
}

function ExpoBanner() {
  return (
    <p data-testid="env-var-expo-banner" className="flex items-start gap-2 rounded-md border border-running/30 bg-running/10 px-2.5 py-1.5 text-[13px] text-running">
      <Icon name="info" size={16} className="mt-px shrink-0" />
      <span>
        <code className="font-mono">EXPO_PUBLIC_*</code> values are embedded in the client JavaScript bundle at build time and are public by definition. Never store signing keys, private credentials or tokens here.
      </span>
    </p>
  );
}
